export { ErrorBoundary, default, loader } from "/tmp/build/apps/asap/src/root.tsx";